document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".hc_logi_yen").forEach(function (el) {
        let num = parseInt(el.textContent.replace(/,/g, ""), 10);
        if (!isNaN(num)) {
            el.textContent = num.toLocaleString();
        }
    });
});


//body内の外部リンクにtarget="_blank"を付与
document.addEventListener("DOMContentLoaded", function() {
  const links = document.querySelectorAll("body a[href]");
  links.forEach(link => {
    const href = link.getAttribute("href");
    if (/^https?:\/\//.test(href) && !href.includes(location.hostname)) {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    }
  });
});
